import { styled } from 'styled-components';

/**
 * Wrapper for the shadow DOM content to ensure styles are scoped correctly.
 */
export const StyledShadowDOMWrapper = styled.div`
  position: relative;

  /* Hide pause button when not hovering over the video container */
  [data-video-container]:not(:hover) button[data-action='pause'] {
    display: none !important;
  }

  [data-video-type='mp4']:not(:hover) button[data-action='pause'] {
    display: none !important;
  }

  button[data-action='play'],
  button[data-action='pause'] {
    background: transparent;
    border: none;
    padding: 0;
    flex-shrink: 0;
    margin: 0;
    cursor: pointer;
    line-height: 0;
    transition: transform 0.3s ease-in-out;
    &:hover {
      transform: scale(1.25);
    }
  }

  [data-video-container] {
    position: absolute;
    pointer-events: none;
  }

  button[data-action='pause'] {
    display: none;
  }

  div[data-video-controls] {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
  }

  & > div > svg {
    display: block;
  }
`;
